import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { capitalize, CircularProgress } from '@mui/material'
import { Box } from '@mui/system'
import { H3 } from '../../../layouts/TextStyles'
import SubjectCard from '../../../components/SubjectCard'
import Breadcrumb from '../../../components/Breadcrumb'
import { courseSubjectApiSlice } from '../../../features/course/courseSubjectSlice'
import { UserSubjectState } from '../../../features/types'
import { ui } from '../../../utils/uiTokens'

const SubjectsPage = () => {
    const { formatMessage, locale } = useIntl()
    const navigate = useNavigate()
    const { state } = useLocation()
    const { data: subjects = [], isFetching: isFetchingSubjects } =
        courseSubjectApiSlice.useFetchAllTeacherSubjectsQuery()

    const handleNavigate = (subject: UserSubjectState) => {
        navigate(`/teacher-courses/subjects/${subject.courseSubjectId}`, {
            state: { course: state?.course, subject: subject },
        })
    }

    return (
        <Wrapper>
            <Breadcrumb
                links={[
                    formatMessage({ id: 'myCourses' }),
                    state?.course?.[`title${capitalize(locale)}`],
                ]}
            />

            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'subjects' })}</H3>
                    </Title>
                </Header>

                <Box sx={{ display: 'flex' }}>
                    {isFetchingSubjects ? (
                        <CircularProgress />
                    ) : subjects.length ? (
                        subjects.map((subject) => (
                            <SubjectCard
                                key={subject.userSubjectEnrollId}
                                subject={subject}
                                onNavigate={handleNavigate}
                            />
                        ))
                    ) : (
                        formatMessage({ id: 'noData' })
                    )}
                </Box>
            </Content>
        </Wrapper>
    )
}

export default SubjectsPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px 40px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
